module.exports = __webpack_public_path__ + "img/f6-2-3.0cd8e238.png";